import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门漫画',
    links: [
      { name: '浪漫爱情', path: '/category/langman-aiqing' },
      { name: '悬疑惊悚', path: '/category/xunyi-jingsong' },
      { name: '奇幻冒险', path: '/category/qihuan-maoxian' },
      { name: '搞笑日常', path: '/category/gaoxiao-richang' },
      { name: '古风恋爱', path: '/category/gufeng-lianai' },
    ],
  },
  {
    title: '内容分类',
    links: [
      { name: '校园青春', path: '/category/xiaoyuan-qingchun' },
      { name: '热血动作', path: '/category/renexue-dongzuo' },
      { name: '都市职场', path: '/category/all' },
      { name: '排行榜', path: '/ranking' },
      { name: '最新上架', path: '/latest' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '常见问题', path: '/about#faq' },
      { name: '联系方式', path: '/about#contact' },
      { name: '用户协议', path: '/terms' },
      { name: '隐私政策', path: '/privacy' },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [subscribeMessage, setSubscribeMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubscribeStatus('success');
      setSubscribeMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    if (!email.trim()) return;

    setSubscribeStatus('submitting');
    formData.delete('website_alt');

    try {
      const response = await fetch('http://98fire.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
        setSubscribeStatus('error');
        setSubscribeMessage(serverMsg.includes('spam') ? '订阅失败，请稍后重试。' : (serverMsg || '订阅失败，请稍后重试。'));
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <footer className="bg-stone-50 border-t border-stone-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[38%]">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-leaf-fill text-2xl text-stone-700"></i>
              </div>
              <span className="text-xl font-bold font-[family-name:var(--font-heading)] text-stone-800">
                韩漫屋
              </span>
            </Link>
            <p className="text-lg font-[family-name:var(--font-heading)] text-stone-700 leading-relaxed mb-3">
              发现美好，<br />阅读快乐。
            </p>
            <p className="text-sm text-stone-400 leading-relaxed mb-10 max-w-sm">
              韩漫屋致力于为华语读者提供最优质的韩国漫画在线阅读体验。海量资源、每日更新、高清画质、纯净浏览。
            </p>

            <div className="max-w-xs">
              <p className="text-xs font-medium text-stone-500 mb-4 uppercase tracking-wider">订阅更新</p>
              <form onSubmit={handleSubscribe} className="space-y-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱地址"
                  required
                  className="w-full bg-transparent border-0 border-b border-stone-300 pb-2 text-sm text-stone-700 placeholder:text-stone-400 outline-none focus:border-stone-500 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="spam-field"
                />
                {subscribeStatus === 'success' && (
                  <p className="text-xs text-green-600">{subscribeMessage}</p>
                )}
                {subscribeStatus === 'error' && (
                  <p className="text-xs text-red-500">{subscribeMessage}</p>
                )}
                <button
                  type="submit"
                  disabled={subscribeStatus === 'submitting'}
                  className="w-full border border-stone-300 rounded-md py-2.5 text-sm font-medium text-stone-600 hover:bg-stone-100 hover:border-stone-400 transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {subscribeStatus === 'submitting' ? '提交中...' : '订阅'}
                </button>
              </form>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            {footerLinks.map((column) => (
              <div key={column.title}>
                <h4 className="text-sm font-medium text-stone-800 mb-5">{column.title}</h4>
                <ul className="space-y-3">
                  {column.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-stone-400 hover:text-stone-700 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-400">
            &copy; {new Date().getFullYear()} 韩漫屋 hanmanwu.com — 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-stone-400 hover:text-stone-600 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-stone-400 hover:text-stone-600 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-stone-400 hover:text-stone-600 transition-colors whitespace-nowrap" rel="nofollow">友情链接</a>
          </div>
        </div>
      </div>
    </footer>
  );
}